export const OrderDayMealSlot = (json: IOrderDayMealSlot): IOrderDayMealSlotModel => {
	const {
		diet_type,
		variant_id,
		is_extra_meal,
		is_selected,
		meal_kind,
		meal_subkind,
		meal_type,
		size_id,
		is_core,
		paid_price,
		sell_price,
		original_price,
		original_sell_price,
		...rest
	} = json

	return {
		dietType: diet_type,
		variantID: variant_id,
		isExtraMeal: is_extra_meal,
		isSelected: is_selected,
		mealKind: meal_kind,
		mealSubkind: meal_subkind,
		mealType: meal_type,
		sizeID: size_id,
		isCore: is_core,
		sellPrice: sell_price,
		paidPrice: paid_price,
		originalPrice: original_price,
		originalSellPrice: original_sell_price,
		...rest,
	}
}

export const OrderDayDiet = (json: IOrderDietDay): IOrderDietDayModel => {
	const fromJSON = (orderDietDay: IOrderDietDay) => {
		const { diet_type, name, diet_group, ...rest } = orderDietDay
		return {
			dietType: diet_type,
			dietGroup: diet_group,
			name: name ? LangContentToModel(name) : { pl: '' },
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const AddonDay = (json: IDietAddonDay): IDietAddonDayModel => {
	const { addon_id, paid_points, paid_price, addon, ...rest } = json

	return {
		addonID: addon_id,
		paidPoints: paid_points,
		paidPrice: paid_price,
		addon: addon ? Addon(addon) : null,
		...rest,
	}
}

export const OrderDay = (json: IOrderDay): IOrderDayModel => {
	const {
		address,
		address_id,
		cart_diet_day_id,
		all_meals_selected,
		client_diet,
		date,
		diet_id,
		diet,
		meal_slots,
		diet_label,
		diet_type,
		diet_group,
		paid_price,
		paid_core_price,
		paid_delivery_price,
		delivery_price,
		original_price,
		original_core_price,
		original_delivery_price,
		addons,
		box_packaging_ids,
		facility_id,
		facility_assigned_at,
		...rest
	} = json

	return {
		address: address ? ClientAddress(address) : null,
		addressID: address_id,
		boxPackingIds: box_packaging_ids,
		cartDietDayID: cart_diet_day_id,
		allMealsSelected: all_meals_selected,
		clientDiet: client_diet ? Order(client_diet) : null,
		date: date ? new Date(date) : null,
		dietID: diet_id,
		diet: diet ? OrderDayDiet(diet) : null,
		mealSlots: meal_slots ? meal_slots.map(OrderDayMealSlot) : [],
		dietLabel: diet_label,
		dietType: diet_type,
		dietGroup: diet_group,
		paidPrice: paid_price,
		paidCorePrice: paid_core_price,
		paidDeliveryPrice: paid_delivery_price,
		deliveryPrice: delivery_price ?? null,
		originalPrice: original_price,
		originalCorePrice: original_core_price,
		originalDeliveryPrice: original_delivery_price,
		addons: addons ? addons.map(AddonDay) : null,
		facilityId: facility_id ?? null,
		facilityAssignedAt: facility_assigned_at ? new Date(facility_assigned_at) : null,
		...rest,
	}
}

export const OrderDayChange = (json: IOrderDayChange): IOrderDayChangeModel => {
	const fromJSON = (orderDayChange: IOrderDayChange) => {
		const {
			client_diet_days,
			new_points_per_day,
			new_price_per_day,
			points_refund,
			points_to_pay,
			price_to_pay,
			...rest
		} = orderDayChange
		return {
			clientDietDays: client_diet_days,
			newPointsPerDay: new_points_per_day,
			newPricePerDay: new_price_per_day,
			pointsRefund: points_refund,
			pointsToPay: points_to_pay,
			priceToPay: price_to_pay,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const orderDayChangeToJSON = (obj: Partial<IOrderDayChangeModel>): Partial<IOrderDayChange> => {
	const {
		clientDietDays,
		newPointsPerDay,
		newPricePerDay,
		pointsRefund,
		pointsToPay,
		priceToPay,
		paymentType,
		...rest
	} = obj
	return {
		client_diet_days: clientDietDays,
		new_points_per_day: newPointsPerDay,
		new_price_per_day: newPricePerDay,
		points_refund: pointsRefund,
		points_to_pay: pointsToPay,
		price_to_pay: priceToPay,
		...(paymentType !== undefined && { employee_payment_type: paymentType }),
		...rest,
	}
}

/**
 * Cancel
 */
export const OrderClientDayCancelCalculation = (
	json: IOrderClientDayCancelCalculation,
): IOrderClientDayCancelCalculationModel => {
	const { refund_amount, affected_client_diet_days } = json

	return {
		refundAmount: refund_amount,
		affectedClientDietDays: affected_client_diet_days,
	}
}

export const OrderClientDayCancelToPayload = (
	obj: IOrderClientDayCancelCalculationModel,
	refundType: ERefundType = ERefundType.VOUCHER,
): IOrderClientDayCancelPayload => {
	const { refundAmount, affectedClientDietDays } = obj
	return {
		refund_amount: refundAmount,
		client_diet_days: affectedClientDietDays,
		refund_type: refundType,
	}
}

export const CancelMealsToPayload = (obj: ICancelMealsPayloadModel): ICancelMealsPayload => ({
	client_meal_slots: obj.clientMealSlots,
	refund_amount: obj.refundAmount,
	refund_type: obj.refundType,
})

export const DietOperationCalculations = (json: IDietOperationCalculations): IDietOperationCalculationsModel => {
	const { ...rest } = json
	return {
		...toCamelCase(rest),
	}
}
